import { render, staticRenderFns } from "./MyPartnerRequests.vue?vue&type=template&id=3b503729&"
import script from "./MyPartnerRequests.vue?vue&type=script&lang=js&"
export * from "./MyPartnerRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports